<template>
  <div class="filters">
    <div class="filters__options">
      <FilterOption
        v-for="item in ordersOptions"
        :key="item.value"
        :checked="selectedTab"
        :value="item.value"
        :label="item.label"
        :disabled="item.disabled"
        :counter="item.counter"
        counter-overflow="9+"
        @change="handleTabChange"
      />
    </div>
    <div v-if="selectedTab === EOrdersType.CONCLUDED" class="filters__selects">
      <FilterSelect
        v-for="(filter, index) in filters"
        :key="index"
        v-model="selectedType"
        use-option-label
        :disabled="disabled"
        :label="filter.type.label"
        :options="filter.options"
        render-menu-with-portal
        @change="option => handleFilterChange(filter.type.value, [option])"
      />
      <FilterSelect
        v-model="selectedPeriod"
        use-option-label
        :disabled="disabled"
        label="Período"
        :options="periodOptions"
        render-menu-with-portal
        @change="option => handleFilterChange('period', option)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from 'vue';

import { FilterOption, FilterSelect } from '@warrenbrasil/nebraska-web';

import { EOrdersType } from './types';
import {
  IFilter,
  IFilterOption
} from '@/modules/wealth/services/portfolio-orders';

interface Props {
  disabled?: boolean;
  filters?: IFilter[];
  periodOptions?: IFilterOption[];
  selectedTab?: EOrdersType;
  openedOrdersCount?: number;
  clearFilters?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  filters: () => [],
  periodOptions: () => [],
  selectedTab: EOrdersType.CONCLUDED,
  openedOrdersCount: 0,
  clearFilters: false
});

interface Emits {
  (event: 'change-tab', value: EOrdersType): void;
  (
    event: 'change-filter',
    value: Record<string, string[] | string>,
    hasFilters: boolean
  ): void;
}

const emits = defineEmits<Emits>();

watch(
  () => props.clearFilters,
  clearFilters => {
    if (clearFilters) {
      selectedType.value = '';
      selectedPeriod.value = '';
      emits('change-filter', { type: [], period: '' }, hasFilters.value);
    }
  },
  { immediate: true }
);

const selectedType = ref('');
const selectedPeriod = ref('');

const ordersOptions = ref([
  {
    label: 'Concluídas',
    value: EOrdersType.CONCLUDED,
    disabled: false,
    counter: null
  },
  {
    label: 'Abertas',
    value: EOrdersType.OPENED,
    disabled: props.openedOrdersCount === 0,
    counter: props.openedOrdersCount
  }
]);

const hasFilters = computed(() => {
  return Boolean(selectedType.value || selectedPeriod.value);
});

function handleTabChange(value: EOrdersType) {
  emits('change-tab', value);
}

function handleFilterChange(type: string, value: string | string[]) {
  emits('change-filter', { [type]: value }, hasFilters.value);
}
</script>

<style lang="less" scoped>
.filters {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__options,
  &__selects {
    display: flex;
    gap: @size-spacing-x300;
  }
}
</style>
